import AppointmentService from "../../Services/AppointmentService";

export const FETCH_APPOINTMENTS_REQUEST = "FETCH_APPOINTMENTS_REQUEST";
export const FETCH_APPOINTMENTS_SUCCESS = "FETCH_APPOINTMENTS_SUCCESS";
export const FETCH_APPOINTMENTS_FAILURE = "FETCH_APPOINTMENTS_FAILURE";

export const FETCH_TODAY_APPOINTMENTS_REQUEST = "FETCH_TODAY_APPOINTMENTS_REQUEST";
export const FETCH_TODAY_APPOINTMENTS_SUCCESS = "FETCH_TODAY_APPOINTMENTS_SUCCESS";
export const FETCH_TODAY_APPOINTMENTS_FAILURE = "FETCH_TODAY_APPOINTMENTS_FAILURE";

export const FETCH_APPOINTMENTS_COUNT_REQUEST = "FETCH_APPOINTMENTS_COUNT_REQUEST";
export const FETCH_APPOINTMENTS_COUNT_SUCCESS = "FETCH_APPOINTMENTS_COUNT_SUCCESS";
export const FETCH_APPOINTMENTS_COUNT_FAILURE = "FETCH_APPOINTMENTS_COUNT_FAILURE";

export const FETCH_APPT_REQUESTLIST_REQUEST = "FETCH_APPT_REQUESTLIST_REQUEST";
export const FETCH_APPT_REQUESTLIST_SUCCESS = "FETCH_APPT_REQUESTLIST_SUCCESS";
export const FETCH_APPT_REQUESTLIST_FAILURE = "FETCH_APPT_REQUESTLIST_FAILURE";

export const fetchAppointments = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_APPOINTMENTS_REQUEST });
    try {
        const response = await AppointmentService.AppointmentList(payload);
        dispatch({ type: FETCH_APPOINTMENTS_SUCCESS, payload: response.data });
    }
    catch (error) {
        dispatch({ type: FETCH_APPOINTMENTS_FAILURE, payload: error.message });
    }
}

export const fetchTodayAppointments = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_TODAY_APPOINTMENTS_REQUEST });
    try {
        const response = await AppointmentService.AppointmentList(payload);
        dispatch({ type: FETCH_TODAY_APPOINTMENTS_SUCCESS, payload: response.data });
    }
    catch (error) {
        dispatch({ type: FETCH_TODAY_APPOINTMENTS_FAILURE, payload: error.message });
    }
}

export const fetchAppointmentsCount = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_APPOINTMENTS_COUNT_REQUEST });
    try {
        const response = await AppointmentService.AppointmentCount(payload);
        dispatch({ type: FETCH_APPOINTMENTS_COUNT_SUCCESS, payload: response.data.TOTAL_COUNT_STATUS });
    }
    catch (error) {
        dispatch({ type: FETCH_APPOINTMENTS_COUNT_FAILURE, payload: error.message });
    }
}

export const fetchApptRequest = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_APPT_REQUESTLIST_REQUEST });
    try {
        const response = await AppointmentService.apptRequestList(payload);
        dispatch({ type: FETCH_APPT_REQUESTLIST_SUCCESS, payload: response.data.data });
    }
    catch (error) {
        dispatch({ type: FETCH_APPT_REQUESTLIST_FAILURE, payload: error.message });
    }
}
